const getPricingUrl = (language) => {
    return "/pricing"
}

export default getPricingUrl